<template>
  <div id="detailInfoModal">
    <div class="searchBox">
      <div>
        <label>기간</label>
        <b-form-input
          type="date"
          class="w200"
          v-model="stdate"
          required
        ></b-form-input>
        <label>~</label>
        <b-form-input
          type="date"
          class="w200"
          v-model="eddate"
          required
        ></b-form-input>
      </div>
      <div>
        <b-button class="searchBtn" @click="getData">조회</b-button>
      </div>
    </div>
    <b-container>
      <b-row>
        <div class="chartarea">
          <b-card
            class="p0 m5 default-border1"
            body-class="p0 h295"
            header-tag="header"
          >
            <h6 slot="header">{{ defaultInfo.thrid.slice(0, -6) }}차트</h6>
            <div id="senThrHistChart1" class="default-border-top1"></div>
          </b-card>
        </div>
      </b-row>
      <b-row class="h240">
        <div class="w-100 h-100">
          <b-card
            class="p0 m5 default-border1"
            body-class="p0 h200"
            header-tag="header"
          >
            <h6 slot="header">Raw 데이터 차트</h6>
            <div
              id="rawdataChart0"
              class="w-100 h200 default-border-top1"
            ></div>
          </b-card>
        </div>
      </b-row>
      <b-row
        v-show="
          defaultInfo.data.datatype !== 's-v' &&
          defaultInfo.thrid !== '트랜드 변화량 임계치 이상'
        "
        class="h240"
      >
        <div class="w-100 h-100">
          <b-card
            class="p0 m5 default-border1"
            body-class="p0 h200"
            header-tag="header"
          >
            <h6 slot="header">Rawe 발생 차트</h6>
            <div id="raweChart0" class="w-100 h200 default-border-top1"></div>
          </b-card>
        </div>
      </b-row>
    </b-container>
    <div class="btnGrp">
      <div class="jcfe">
        <b-button
          class="empty-delBtn"
          style="margin: 0px 20px"
          @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import utils from "../common/utils";
import chartUtil from "../common/chartUtil";
import moment from "moment";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  computed: {
    ...mapGetters(["getCenterBus", "getUserId", "getUserAuth"]),
  },
  props: {
    defaultInfo: {
      // {data: {occurtime, alarmname, level, stname, devid, devname, ch, alarmsource, detailinfo, datatype}, stid, thrid, title}
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      stdate: null,
      eddate: null,
      samplecnt: 1,
      rawDataChartLine: null,
    };
  },
  setup() {},
  created() {
    this.stdate = moment(this.defaultInfo.data.occurtime)
      .subtract(3, "days")
      .format("YYYY-MM-DD");
    this.eddate = moment(this.defaultInfo.data.occurtime)
      .add(3, "days")
      .format("YYYY-MM-DD");
  },
  mounted() {
    this.getData();
  },
  unmounted() {},
  methods: {
    ...mapMutations(["setAlertTitle"]),
    getData() {
      this.getSensorThrHistForChart();
      this.defaultInfo.thrid === "트랜드 변화량 임계치 이상"
        ? this.getTrendRawData()
        : this.getDataForChart();
      // console.log(this.defaultInfo)
    },
    getSensorThrHistForChart() {
      let reqBody = {
        stid: this.defaultInfo.stid,
        deviceid: this.defaultInfo.data.deviceid,
        channel: this.defaultInfo.data.channel,
        datatype: this.defaultInfo.data.datatype,
        thrid: this.defaultInfo.thrid,
        stdate: this.stdate,
        eddate: this.eddate,
      };
      this.$http
        .post("/event/getSensorThrChgHist", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let chg = res.data.data.chg;
            let alarmLine = res.data.data.alarmLine;
            let chartData = { x: [], y: [] };
            let lines = [];
            for (let i = 0; i < chg.length; i++) {
              chartData.x.push(chg[i].datatime);
              chartData.y.push(chg[i].chg);
            }
            lines = [
              alarmLine[0].warnVal,
              alarmLine[0].critVal,
              alarmLine[0].dangVal,
            ];
            this.$nextTick(() => {
              this.drawTimeLineChart1(
                "senThrHistChart1",
                {
                  data: {
                    x: chartData.x,
                    y: chartData.y,
                  },
                  annotation: {
                    yaxis: {
                      text: this.defaultInfo.thrid.slice(0, -7),
                      x: -0.08,
                      y: 0.5,
                    },
                  },
                  lines: lines,
                },
                {
                  xrange: [reqBody.stdate, reqBody.eddate],
                }
              );
            });
          } else {
            this.setAlertTitle("데이터 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    drawTimeLineChart1(id, param, range) {
      let data = [];
      data.push({
        x: param.data.x,
        y: param.data.y,
        type: "scatter",
        mode: "lines+markers",
        line: { width: 1 },
        name: "",
      });
      data.push({
        x: [range.xrange[1], range.xrange[1], range.xrange[1]],
        y: [param.lines.warn, param.lines.crit, param.lines.dang],
        text: ["주의", "경고", "심각"],
        textposition: "top right",
        mode: "text",
        textfont: {
          color: "#b4b7bd",
        },
        hoverinfo: "none",
      });
      let layout = chartUtil.setLayout(id, {
        margin: {
          l:
            utils.chkNull(param.annotation) !== null &&
            utils.chkNull(param.annotation.yaxis) !== null
              ? 90
              : 50,
          r: 50,
          t: 40,
          b: 50,
          pad: 10,
        },
        annotation: param.annotation,
        showlegend: false,
      });
      layout.xaxis.tickformat = "%Y-%m-%d";
      layout.xaxis.dtick = 86400000.0;
      layout.width = 1127;
      layout.height = 293;
      // layout.xaxis.range = range.xrange
      layout.shapes = [];
      layout.shapes.push({
        // 해당 날짜 하이라이트
        type: "line",
        xref: "x",
        yref: "paper",
        x0: this.defaultInfo.data.occurtime,
        y0: 0,
        x1: this.defaultInfo.data.occurtime,
        y1: 1,
        opacity: 0.2,
        line: {
          color: "#d3d3d3",
          width: 20,
          dash: "line",
        },
      });
      if (param.lines != null) {
        // 장애등급선
        let lineColor = ["#ff4", "#ff8510", "#f00"];
        for (let i = 0; i < param.lines.length; i++) {
          layout.shapes.push({
            type: "line",
            xref: "paper",
            x0: 0,
            y0: param.lines[i],
            x1: 1,
            y1: param.lines[i],
            line: {
              color: lineColor[i],
              width: 1,
              dash: "longdash",
            },
          });
        }
      }
      Plotly.newPlot(id, data, layout, { scrollZoom: true });
    },
    getDataForChart() {
      let reqBody = {
        stdate: this.stdate.replace(/-/g, ""),
        stdatehi: this.stdate,
        eddate: this.eddate.replace(/-/g, ""),
        eddatehi: this.eddate,
        deviceid: this.defaultInfo.data.deviceid,
        channel: this.defaultInfo.data.channel,
        samplecnt: this.samplecnt,
        datatype: this.defaultInfo.data.datatype,
      };
      let indexOfData;
      switch (reqBody.datatype) {
        case "anal1":
        case "s-v":
          indexOfData = 1;
          break;
        case "anal2":
          indexOfData = 2;
          break;
      }
      this.$http
        .post("/event/getChartData", reqBody, { timeout: 60000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data.rawdata.data;
            let chartData = { time: [], value: [], rawe: [] };
            let data2 = res.data.data.rawecnt;
            let chartData2 = { time: [], rawecnt: [] };
            for (let i = 0; i < data.length; i++) {
              chartData.time.push(
                moment.unix(data[i][0]).format("YYYY-MM-DD HH:mm:ss")
              );
              chartData.value.push(data[i][indexOfData]);
              if (data[i][5] != null) {
                chartData.rawe.push(data[i][5]);
              }
            }
            for (let j = 0; j < data2.length; j++) {
              chartData2.time.push(data2[j].collecttime);
              chartData2.rawecnt.push(data2[j].datacnt);
            }
            let thrmode = res.data.data.thrmode;
            let initval = res.data.data.initval;
            let line = res.data.data.line;
            console.log(initval);
            if (utils.isStaticSensor(this.defaultInfo.data.devicetype)) {
              if (thrmode === "H" || thrmode === null) {
                this.rawDataChartLine = [
                  initval,
                  initval + line.warnVal,
                  initval + line.critVal,
                  initval + line.dangVal,
                ];
              } else if (thrmode === "L") {
                this.rawDataChartLine = [
                  initval,
                  initval - line.warnVal,
                  initval - line.critVal,
                  initval - line.dangVal,
                ];
              } else if (thrmode === "HL") {
                this.rawDataChartLine = [
                  initval,
                  initval - line.warnVal,
                  initval - line.critVal,
                  initval - line.dangVal,
                  initval + line.warnVal,
                  initval + line.critVal,
                  initval + line.dangVal,
                ];
              }
            }
            // line 추가해야 함
            this.$nextTick(() => {
              this.drawRawdataChart("rawdataChart0", {
                x: chartData.time,
                y: chartData.value,
                name: "raw data",
                line: this.rawDataChartLine,
              });
              this.drawRaweChart("raweChart0", {
                x1: chartData.time,
                y1: chartData.rawe,
                name1: "rawe 발생 여부",
                x2: chartData2.time,
                y2: chartData2.rawecnt,
                name2: "rawe 개수",
                annotation: {
                  yaxis: {
                    text: "Rawe 발생 여부",
                    x: -0.05,
                    y: 0.5,
                  },
                  yaxis2: {
                    text: "Rawe 개수",
                    x: 1.05,
                    y: 0.5,
                  },
                },
              });
            });
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getTrendRawData() {
      let reqBody = {
        device_id: this.defaultInfo.data.deviceid,
        device_type: this.defaultInfo.data.devicetype,
        channel: this.defaultInfo.data.channel,
        st_time: this.stdate.replace(/-/g, ""),
        ed_time: this.eddate.replace(/-/g, ""),
      };
      let key = "";
      switch (this.defaultInfo.data.datatype) {
        case "anal1":
          key = "anal1";
          break;
        case "anal2":
          key = "anal2";
          break;
        case "s-v":
          key = "data";
          break;
      }
      this.$http
        .post("/event/getTrendRawData", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data.rawdata;
            let initval = res.data.data.initval; // devicetype = '2'
            let line = res.data.data.line; // devicetype = '2'
            let thrmode = res.data.data.thrmode;
            let chartData = { x: [], y: [] };

            chartData.x = data.datatime[i];
            chartData.y = key === "data" ? data[key][0][key] : data[key];

            this.rawDataChartLine = null;
            if (utils.isStaticSensor(this.defaultInfo.data.devicetype)) {
              if (thrmode === "H" || thrmode === null) {
                this.rawDataChartLine = [
                  initval,
                  initval + line.warnVal,
                  initval + line.critVal,
                  initval + line.dangVal,
                ];
              } else if (thrmode === "L") {
                this.rawDataChartLine = [
                  initval,
                  initval - line.warnVal,
                  initval - line.critVal,
                  initval - line.dangVal,
                ];
              } else if (thrmode === "HL") {
                this.rawDataChartLine = [
                  initval,
                  initval - line.warnVal,
                  initval - line.critVal,
                  initval - line.dangVal,
                  initval + line.warnVal,
                  initval + line.critVal,
                  initval + line.dangVal,
                ];
              }
            }
            this.$nextTick(() => {
              this.drawRawdataChart("rawdataChart0", {
                x: chartData.x,
                y: chartData.y,
                name: "raw data",
                line: line === undefined ? null : this.rawDataChartLine,
              });
            });
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.LoadYn = false;
          console.error(err);
        });
    },
    drawRawdataChart(id, options, range) {
      console.log(options.line);
      let data = [];
      data.push({
        x: options.x,
        y: options.y,
        type: "scatter",
        mode: "lines",
        line: { width: 1 },
      });
      let layout = chartUtil.setTimeLayout(id, {
        margin: {
          l: 50,
          r: 30,
          t: 30,
          b: 50,
          pad: 10,
        },
        annotation: options.annotation,
        showlegend: false,
      });
      layout.shapes = [];
      layout.shapes.push({
        type: "rect",
        // x-reference is assigned to the x-values
        xref: "x",
        // y-reference is assigned to the plot paper [0,1]
        yref: "paper",
        x0: this.defaultInfo.data.occurtime + " 00:00:00",
        y0: 0,
        x1: this.defaultInfo.data.occurtime + " 23:59:59",
        y1: 1,
        fillcolor: "#d3d3d3",
        opacity: 0.2,
        line: {
          width: 0,
        },
      });
      if (options.line != null) {
        let lineColor = [
          "#fff",
          "#ff4",
          "#ff8510",
          "#f00",
          "#ff4",
          "#ff8510",
          "#f00",
        ];
        for (let i = 0; i < options.line.length; i++) {
          layout.shapes.push({
            type: "line",
            xref: "paper",
            x0: 0,
            y0: options.line[i],
            x1: 1,
            y1: options.line[i],
            line: {
              color: lineColor[i],
              width: 1,
              dash: "longdash",
            },
          });
        }
      }
      layout.xaxis.dtick = 86400000.0;
      Plotly.newPlot(id, data, layout, { scrollZoom: true });
    },
    drawRaweChart(id, options, range) {
      let data = [
        {
          x: options.x1,
          y: options.y1,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
          name: options.name1,
        },
        {
          x: options.x2,
          y: options.y2,
          type: "scatter",
          mode: "lines",
          yaxis: "y2",
          line: { width: 1 },
          name: options.name2,
        },
      ];
      let layout = chartUtil.setDualAxisTimeLayout(id, options);
      layout.margin = {
        l: 50,
        r: 50,
        t: 10,
        b: 30,
        pad: 0,
      };
      // layout.annotation
      layout.shapes = [
        {
          type: "rect",
          // x-reference is assigned to the x-values
          xref: "x",
          // y-reference is assigned to the plot paper [0,1]
          yref: "paper",
          x0: this.defaultInfo.data.occurtime + " 00:00:00",
          y0: 0,
          x1: this.defaultInfo.data.occurtime + " 23:59:59",
          y1: 1,
          fillcolor: "#d3d3d3",
          opacity: 0.2,
          line: {
            width: 0,
          },
        },
      ];
      layout.showlegend = false;
      layout.xaxis.dtick = 86400000.0;
      layout.yaxis.nticks = 2;
      Plotly.newPlot(id, data, layout, { scrollZoom: true });
    },
    closeModal() {
      this.$bvModal.hide("detailInfoModal");
    },
  },
};
</script>
<style lang="scss">
#detailInfoModal .modal-dialog {
  max-width: 1200px;
  padding: 15px;
  .container {
    padding: 0;
    .row {
      height: 341px;
    }
  }
  & .searchBox {
    justify-content: space-between;
  }
  .chartarea {
    height: 331px;
    width: 100%;
  }
  .graph {
    width: 100%;
    height: 295px;
  }
  .card-header {
    padding: 6px 15px 8px;
    border-bottom: 1px solid #1f2327;
    & h6 {
      font-size: 15px;
      line-height: unset;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/ThresholdDetailModal.vue